/**
 * Sorting passed array of objects by key with number value
 * returns sorted array.
 * @param {list} array - chosen array to be sorted
 * @param {key} string - key with Number value
 * @returns {array} - array sorted by key 
 */
export const sortNumbersByKey = (list, key) => list.sort((a, b) => a[key] - b[key]);
